import React from "react";
import { VerticalTimeline, VerticalTimelineElement } from 'react-vertical-timeline-component';
import 'react-vertical-timeline-component/style.min.css';
import WorkIcon from "../../assets/img/skills/icons8-work-50.png";


// projects

import L_foodHouse from "../../assets/img/projects/foodHouse.png";
import L_docketProject from "../../assets/img/projects/docketProject.png";
import L_snakeGame from "../../assets/img/projects/snakeGame.png";
import L_drumKitProject from "../../assets/img/projects/drumKitProject.png";
import Accordion from "react-bootstrap/Accordion";
import Card from "react-bootstrap/Card";

// skills

import L_NODE_JS from "../../assets/img/skills/nodejs.svg";
import L_EXPRESS from "../../assets/img/skills/express.svg";

import L_MONGODB from "../../assets/img/skills/mongodb.svg";
import Image from "react-bootstrap/Image";

import L_HTML5 from "../../assets/img/skills/html-5.svg";
import L_CSS3 from "../../assets/img/skills/css3.svg";
import L_BOOTSTRAP4 from "../../assets/img/skills/bootstrap-4.svg";
import L_DJANGO from "../../assets/img/skills/javascriptLogo.png";



import "./projects-timeline.styles.css";

const ExperienceTimeLine = () => {
  return (
    <div>
      <h1 className="pt-3 text-center font-details-b pb-3">WORK EXPERIENCE</h1>
      <VerticalTimeline>
        <VerticalTimelineElement
          className="vertical-timeline-element--work"
          contentStyle={{ background: '#1d8fe1', color: '#ffffff' }}
          contentArrowStyle={{ borderRight: '7px solid #1d8fe1' }}
          date="January, 2023 - Present"
          iconStyle={{
            background: '#1d8fe1',
            color: '#ffffff',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
          }}
          icon={
            <img
              src={WorkIcon}
              alt="Work"
              style={{ width: '50%', height: '50%' }}
            />
          }
        >

          <h3 className="vertical-timeline-element-subtitle">Accenture</h3>
          <h5 className="vertical-timeline-element-title">Advanced App Engineering Analyst, </h5>
          <br />
          <ul>
            <li>Developing and maintaining RESTful APIs using Java, Spring Boot, and JPA, ensuring scalability and performance.</li>
            <li>Collaborating with cross-functional teams to design, develop, and deploy microservices-based applications.</li>
            <li>Implementing database operations using PostgreSQL/MS SQL, optimizing queries for better performance.</li>
            <li>Integrating third-party services and APIs to enhance application functionality.</li>
            <li>Working on AWS deployment and handling cloud-based infrastructure configurations.</li>
            <li>Ensuring code quality, security, and performance by participating in code reviews and implementing best practices.</li>
            <li>Troubleshooting and resolving production issues to minimize downtime and ensure system stability.</li>
            <li>Writing unit and integration tests to maintain high code quality and reliability.</li>
            <li>Collaborating with QA teams to support testing and debugging activities.</li>
            <li>Documenting technical specifications and providing support during code handovers.</li>
          </ul>


        </VerticalTimelineElement>
        <VerticalTimelineElement
          className="vertical-timeline-element--work"
          contentStyle={{ background: '#1d8fe1', color: '#ffffff' }}
          contentArrowStyle={{ borderRight: '7px solid #1d8fe1' }}
          date="July, 2022 - December, 2022"
          iconStyle={{
            background: '#1d8fe1',
            color: '#ffffff',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
          }}
          icon={
            <img
              src={WorkIcon}
              alt="Work"
              style={{ width: '50%', height: '50%' }}
            />
          }
        >
          <h3 className="vertical-timeline-element-subtitle">Inofinity R&D </h3>
          <h5 className="vertical-timeline-element-title">Java Developer Intern, </h5>
          <br />
          <ul>
            <li>
              Successfully developed a sensor-integrated real-time CPR training system,
              leveraging WebSocket-based data streaming for instant feedback and performance monitoring using Java, Spring Boot, and React.
            </li>
            <li>
              Designed engaging user interfaces with dynamic visualizations to enhance user experience. Adept at optimizing backend performance through multi-threading and low-latency data processing, ensuring accurate and efficient real-time analytics.
            </li>

          </ul>
        </VerticalTimelineElement>
      </VerticalTimeline>
    </div>
  );
};

export default ExperienceTimeLine;
